export default "__VITE_ASSET__36a1c9d3__"